import styles from '../centralAntrag.module.css';
import { useEffect, useState } from "react";
import { kurs_absagen } from '../../../../../config/meta-informationen';
import { showErrorToast } from '../../../../../code/ToastHelper';
function AbmeldungKurs() {
    const [submitted, setSubmitted] = useState(false);
    const [formData, setFormData] = useState({
        formType: "kursAbmeldung",
        vorname: "",
        nachname: "",
        email: "",
        thema: "",
        nachricht: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch("/api/email/send-emails", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (response.ok) {
                setSubmitted(true);
            } else {
                showErrorToast("Fehler beim Senden: " + result.message)
            }

        } catch (error) {
            console.error("Ein Fehler ist aufgetreten:", error);
            showErrorToast("Beim Senden der Anfrage ist ein Fehler aufgetreten.")
        }
        setSubmitted(true)
    };

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);

        const matchingKey = Object.keys(kurs_absagen).find(key =>
            params.has(key)
        );

        if (matchingKey) {
            setFormData(prev => ({
                ...prev,
                thema: matchingKey, // store the key, not the label
            }));
        }
    }, []);
    return (
        <section className={styles.container}>
            <h1>Kursabmeldung</h1>

            {!submitted ? (
                <form className={styles.formular} onSubmit={handleSubmit}>
                    <div className={styles.section}>
                        <p className={styles.sectionTitle}>Allgemeine Daten</p>
                        <div className={styles.area}>
                            <label>
                                <div>Vorname <span className={styles.required}>*</span></div>
                                <input type="text" name="vorname" placeholder='Max' required onChange={handleChange} />
                            </label>
                            <label>
                                <div>Nachname <span className={styles.required}>*</span></div>
                                <input type="text" name="nachname" placeholder='Mustermann' required onChange={handleChange} />
                            </label>
                        </div>
                        <div className={styles.area}>
                            <label>
                                <div>E-Mail <span className={styles.required}>*</span></div>
                                <input type='email' name='email' placeholder='max.mustermann@musteradresse.de' required onChange={handleChange}></input>
                            </label>
                        </div>
                    </div>
                    <div className={styles.section}>
                        <p className={styles.sectionTitle}>Begründung</p>
                        <div className={styles.area}>
                            <label>
                                <div>Thema <span className={styles.required}>*</span></div>
                                <select
                                    name="thema"
                                    value={formData.thema}
                                    onChange={(e) =>
                                        setFormData({ ...formData, thema: e.target.value })
                                    }
                                    required
                                >
                                    <option value="" disabled>Wähle einen Kurs aus...</option>
                                    {Object.entries(kurs_absagen).map(([key, value]) => (
                                        <option key={key} value={value}>
                                            Kursabsage: {value}
                                        </option>
                                    ))}
                                </select>
                            </label>
                        </div>
                        <div className={styles.area}>
                            <label>
                                <div>Begründung</div>
                                <textarea name="nachricht" placeholder="Warum können Sie an dem Kurs nicht teilnehmen?" onChange={handleChange}></textarea>
                            </label>
                        </div>
                    </div>
                    <button type="submit">Absenden</button>
                </form>
            ) : (
                <div className={styles.bestaetigung}>
                    <img src='/images/logo.png' alt='Logo: TuS-05-Oberpleis'></img>
                    <div className={styles.text}>
                        <p>Die Kursabmeldung wurde erfolgreich übermittelt!</p>
                        <p>Sie erhalten zusätzlich eine Bestätigung per E-Mail.</p>
                    </div>
                    <img className={styles.secondImg} src='/images/logo.png' alt='Logo: TuS-05-Oberpleis'></img>
                </div>
            )}
        </section >
    )
}

export default AbmeldungKurs;